import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.CardVerificationRetryModal
**/
HSN.CardVerificationRetryModal = (function (parent) {
    __extends(CardVerificationRetryModal, parent);

    function CardVerificationRetryModal() {
        var modal = CardVerificationRetryModal.__super__.constructor.call(this, 'card-verification-modal');

            this.commerceService = HSN.Instance()._getCommerceService();
            this.paymentService = HSN.Instance()._getPaymentService();
            this.isTokenizerOk = false;
            this.name = 'HSN.CardVerificationRetryModal';
            this.Close.off();
            eventHandlers(this);
            return modal;
        }

    function eventHandlers(modal) {
        $(modal.Content).on('click', '#continue', function () {
            cmCreateManualLinkClickTag('/checkout/card-verification-retry?cm_sp=CVV-_-Continue-_-226&cm_re=CVV-_-Continue-_-226', '');
            HSN.Instance().ccTokenizerSocket.tokenize(function (response) {
                modal.isTokenizerOk = true;
                if (response.error) {
                    var responseError = {
                        'errorFields': [{ 'Key': 'cvv', 'Value': response.error.faultDetail }],
                        'errors': [response.error.faultDetail],
                        'success': false
                    };
                    HSN.AddErrorTreatment('#cardVerificationForm', responseError, modal.Content);
                }
                else {
                    $('#cardVerificationTransactionId').val(response.data.transactionID);
                    modal.commerceService.ResubmitCardVerification({ orderIdentity: modal.orderNumber, cardVerificationTransactionId: response.data.transactionID }, {
                        callback: function (data) {
                            if (data.success) {
                                window.location = data.NextUrl;
                            }
                            else if (data.RequiresCardVerificationRetry) {
                                HSN.RemoveWait();
                                HSN.Instance().GetCardVerificationRetryModal().Show(true, data.CvvUrl, data.OrderNumber);
                            }
                            else if(data.NextUrl) {
                                window.location = data.NextUrl;
                            }
                            else {
                                HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was an error attempting to resubmit your order, please try again.');
                            }
                        }
                    });
                }
                return false;
            });
        });

        $(modal.Content).on('click', '#cancel', function () {
            cmCreateManualLinkClickTag('/checkout/card-verification-retry?cm_sp=CVV-_-Cancel-_-226&cm_re=CVV-_-Cancel-_-226', '');
            modal.Hide();
            return false;
        });
    }

    CardVerificationRetryModal.prototype._show = function (isError, tokenizationUrl, orderNumber) {
        var scope = this;
        scope.AddLoadingSpinner();
        scope.orderNumber = orderNumber;

        let easyXdmPromise = import(/* webpackChunkName: "easyXDM" */ 'LIBS/easyXDM.js');

        let ajax = $.ajax('/checkout/card-verification-retry?isError=' + isError,
            {
                context: this,
                dataType: 'html'
            }
        );

        Promise.all([ajax, easyXdmPromise])
            .then(([content, EasyXDMLoaded]) => {
                cmCreateManualLinkClickTag('/checkout/card-verification-retry?cm_sp=CVV-_-Error-_-226&cm_re=CVV-_-Error-_-226', '');
                scope.RemoveLoadingSpinner();
                this.Content.showHtml(
                    content,
                    0,
                    function () {
                        scope.Center();
                        scope.Content.animate({ opacity: 1 });
                        scope.Root.find('#closeModal').remove();
                    },
                    function () {}
                );

                HSN.Instance().ccTokenizerSocket = new easyXDM.Rpc(
                    {
                        remote: tokenizationUrl,
                        props: {
                            id: 'card-verification-frame',
                            frameborder: 0,
                            scrolling: 'no',
                            style: {
                                overflow: 'hidden',
                                width: '200px',
                                height: '62px',
                                allowTransparency: 'true',
                                margin: '5px auto'
                            }
                        },
                        container: $('#card-verification-container')[0]
                    },
                    {
                        remote: {
                            tokenize: {},
                            clearTextBox: {},
                            status: {}
                        }
                    });

                    window.setTimeout(function () {
                        HSN.Instance().ccTokenizerSocket.status(function () {
                            scope.isTokenizerOk = true;
                        });
                    }, 4800);
                    window.setTimeout(function () {
                        if (!scope.isTokenizerOk) {
                            scope.paymentService.LogTokenizerFailure({ Type: 'CVV' }, {});
                        }
                    }, 5000);
                })
                .catch(() => {
                    alert('Unfortunately there was an error attempting to load the content, please try again.');
                    scope.RemoveLoadingSpinner();
                    scope.Hide();
                });
    };
    return CardVerificationRetryModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/Checkout/CardVerificationRetryModal.js